import { render, staticRenderFns } from "./DeactiveMasterThesis.vue?vue&type=template&id=5b4eaa68&"
import script from "./DeactiveMasterThesis.vue?vue&type=script&lang=js&"
export * from "./DeactiveMasterThesis.vue?vue&type=script&lang=js&"
import style0 from "./DeactiveMasterThesis.vue?vue&type=style&index=0&id=5b4eaa68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports